<script>
//import VueSlideBar from "vue-slide-bar";
import { FormWizard, TabContent } from "vue-form-wizard";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import moment from "moment";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import AnktAnket from "@/models/AnktAnket";
import mesaj from "../FormComponet/mesajComponent.vue"
import store from "@/state/store";
import { MethodsActionsLoginSessionKey } from "@/state/helpers";

export default {
  mixins: [Api, Sabit, AnktAnket],

  page: {
    title: "Anketler",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    mesaj,
    FormWizard, TabContent,
    //VueSlideBar
  },
  data() {
    return {
      title: this.$t("AnktAnket.Title"),
      items: [
        {
          text: this.$t("AnktAnket.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("AnktAnket.Title"),
          active: true,
        },
      ],
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      FormData: {
        Anketid: "",
        Cevap: "",
        Clientipadress: null,
        tekilkontrolid:null,
        CreatedBy: "string",
        Created: moment(new Date()).format('YYYY-MM-DDTHH:mm:ss') + "Z",
      },
      AuthKontrol: store.getters["auth/isAuth"],
      AuthKontrol2: null,
      DosyaYolu: "",
      FormDataJson: {
      },
      DefaultPage: 1,
      AnketData: null,
      Anketjson: [],
      AnktAnketId: this.$route.params.AnktAnketId,
      index: "",
      radiobutton: {},
      AnketCevapIpKontrol: false,

      AnketCevapKullaniciKontrol: false,
      Cevaplayanid: null,
      Cevaplayanid2: null,
      AnktAnketCevapYanitlamaCevap: "",
      ErteleKontrol: false,
      Ertele: false,
      Yanitlamakistemiyorum: false,
      Baslamatarihi: "",
      Bitistarihi: "",
      ResimYolu: "",
      AnketBitisKontrol: false,
      Anketkapalimi: false,
      Anketkapalimesaji: "",
      AnktSucceeded: false,
      contentBackGroundColor: {
        backgroundColor: ""
      },
      themeColor: "",
      Update: 0,
      ButtonDisabled: false

    };
  },

  methods: {

    ...MethodsActionsLoginSessionKey,
    bgColorChange() {
      document.body.style.backgroundColor = this.themeColor;
    },

    loadOrCreateToken() {
      // localStorage'den oku
      let token = localStorage.getItem("tekilkontrolid");

      if (!token) {
        // Eğer yoksa GUID oluştur
        token = crypto.randomUUID(); // modern tarayıcılarda desteklenir
        localStorage.setItem("tekilkontrolid", token);

          this.FormData.tekilkontrolid = token;
  
      } else {

              this.FormData.tekilkontrolid = token;

        this.ActionsFilterGet({
        Service: "AnktAnketCevap",
        Page: this.Page,
        Filter: "&Tekilkontrolid=" + this.FormData.tekilkontrolid
        + "&Anketid=" + this.$route.params.AnktAnketId
      }).then((res) => {

        let CevapData = JSON.parse(res.Data);
        let DataSize = CevapData.length;
        if (DataSize !== 0) {

          this.AnketCevapIpKontrol = true;
       
        }
      });


      }


    } ,

    FileUpload(event, Field) {

      let file = event.target.files[0];
      let x = file.name;
      //this.FormData.Filename = this.file.name;
      let uzanti = x.substr(
        x.lastIndexOf(".") + 1,
        x.length - x.lastIndexOf(".")
      );

      if (uzanti == 'pdf' || uzanti == 'png' || uzanti == 'jpeg' || uzanti == 'jpg'
        || uzanti == 'xls' || uzanti == 'xlsx' || uzanti == 'doc' || uzanti == 'docx') {

        let formData = new FormData();
        formData.append("file", file);
        this.ActionsPost({
          Service: "GenericFileUpDownload/UploadFile?pathUrl=Ankt",
          Data: formData,
        }).then((res) => {
          if (res.Succeeded == true) {
            this.FormDataJson[Field].Cevap = "Ankt/" + res.Data.filename;
            this.$toast.success(this.$t("ToasMessage.FilePozitif"));
          } else {
            this.$toast.error(this.$t("ToasMessage.FileNegatif"));
          }
        });
      } else {
        this.$toast.error(this.$t("ToasMessage.FileNegatifUzanti"));
      }
    },

    ShowYanitSoru() {
      if (this.AnketCevapKullaniciKontrol != true && this.AnketCevapIpKontrol != true && this.ErteleKontrol != true) {

        if (this.Ertele == true || this.Yanitlamakistemiyorum == true) {

          this.$bvModal.show("AnktAnketCevapYanitlama");
        }
      }
    },
    Get(){
     
    },
    
   async GetData() {
  try {

    this.AnktSucceeded = false;
    this.FormDataJson = {};
    this.Anketjson = [];

    /* ---------------------------------
     * 1️⃣ Anketi çek
     * --------------------------------- */
    const Anketres = await this.ActionsSingleGet({
      Service: "AnktAnket",
      Id: this.AnktAnketId,
    });

    if (!Anketres?.Succeeded) return;

    const data = Anketres.Data;
    this.AnktSucceeded = true;

          this.AnketData = data;


    if (data.Ipkontrol === true) {
      await this.loadOrCreateToken();

    } else {
      let token = localStorage.getItem("tekilkontrolid");
      if (!token) {
        token = crypto.randomUUID();
        localStorage.setItem("tekilkontrolid", token);
      }
      this.FormData.tekilkontrolid = token;
    }

    /* ---------------------------------
     * 3️⃣ Anket temel ayarları
     * --------------------------------- */
    this.contentBackGroundColor.backgroundColor = data.BackgroundColor;
    this.themeColor = data.BackgroundColor;
    this.Anketkapalimi = data.Anketkapalimi;
    this.Anketkapalimesaji = data.Anketkapalimesaji;
    this.Baslamatarihi = data.Baslamatarihi;
    this.Bitistarihi = data.Bitistarihi;
    this.Ertele = data.Ertele;
    this.Yanitlamakistemiyorum = data.Yanitlamakistemiyorum;

    this.DosyaYolu = this.$config.FILES_URL;
    this.AuthKontrol2 = window.$cookies.get("eCampus");

    /* ---------------------------------
     * 4️⃣ SessionKey / Kullanıcı çözümleme
     * --------------------------------- */
    if (this.$route.params.Sessionkey && this.$route.params.Email) {
      const loginOk = await this.ActionsLoginSessionKey({
        Email: this.$route.params.Email,
        Sessionkey: this.$route.params.Sessionkey,
      });

      if (loginOk !== true) {
        window.location = this.$config.LOGIN_URL;
        return;
      }

      if (this.AuthKontrol2) {
        this.Cevaplayanid = this.TokenUserId;
      } else {
        const userRes = await this.ActionsFilterGet({
          Service: this.$config.API_ACCOUNT_URL + "Account/get-userroles",
          Page: { PageNumber: "1", PageSize: "9999", PageDataSize: "1" },
          Filter: "&email=" + this.$route.params.Email,
        });
        this.Cevaplayanid = userRes?.Data?.Id ?? null;
      }
    }

    /* ---------------------------------
     * 5️⃣ Kullanıcı daha önce cevaplamış mı
     * --------------------------------- */
    if (this.Cevaplayanid) {
      const cevapRes = await this.ActionsFilterGet({
        Service: "AnktAnketCevaplanPersonel",
        Page: this.Page,
        Filter:
          "&Cevaplayanid=" +
          this.Cevaplayanid +
          "&Anketid=" +
          this.AnktAnketId,
      });

      cevapRes?.Data?.forEach(x => {
        if (x.Durumid === 1) this.AnketCevapKullaniciKontrol = true;
        if (x.Durumid === 2) this.ErteleKontrol = true;
      });
    }

    /* ---------------------------------
     * 6️⃣ IP bazlı cevap kontrolü
     * --------------------------------- */
    if (data.Ipkontrol === true) {
      const ipRes = await this.ActionsFilterGet({
        Service: "AnktAnketCevap",
        Page: this.Page,
        Filter:"&Tekilkontrolid=" +
          this.FormData.tekilkontrolid +
          "&Anketid=" +
          this.AnktAnketId,
      });

      const cevaplar = JSON.parse(ipRes?.Data || "[]");
      this.AnketCevapIpKontrol = cevaplar.length > 0;

      if (!this.AnketCevapIpKontrol) {
        this.ShowYanitSoru();
      }
    } else {
      this.ShowYanitSoru();
    }

    /* ---------------------------------
     * 7️⃣ Form JSON parse
     * --------------------------------- */
    this.Anketjson = JSON.parse(data.Anketjson);

    /* ---------------------------------
     * 8️⃣ FormDataJson build (Vue 2 SAFE)
     * --------------------------------- */
    this.Anketjson.forEach(form => {
      form.FormFiled.forEach(field => {
        let cevap = "";

        if (field.type === "checkbox") {
          cevap = [];
        }
        else if (field.type === "rangeslider") {
          cevap = null;
        }
        else if (field.type === "CoktanSecmeliTablo") {
          cevap = {};
          field.options.Satir.forEach(s => {
            this.$set(cevap, s.Id, "");
          });
        }
        else if (field.type === "OnayKutuluTablo") {
          cevap = {};
          field.options.Satir.forEach(s => {
            this.$set(cevap, s.Id, []);
          });
        }

        this.$set(this.FormDataJson, field.Id, {
          SiraNo: field.SiraNo,
          Type: field.type,
          Text: field.props.title,
          Cevap: cevap,
        });
      });
    });

  } catch (err) {
    console.error("GetData error:", err);
    this.AnktSucceeded = false;
  }
}
,
    
    onSubmitCevapYanitlama() {
      let AnktAnketCevaplanPersonelData = {
        Deleted: false,
        Anketid: this.AnktAnketId,
        Durumid: this.AnktAnketCevapYanitlamaCevap,
        Cevaplayanid: this.Cevaplayanid
      }
      this.Post("AnktAnketCevaplanPersonel", AnktAnketCevaplanPersonelData).then((res) => {
        if (res) {
           this.$bvModal.hide("AnktAnketCevapYanitlama")
        }
      });
    },
    onSubmit(index) {

      this.FormData.Anketid = this.AnktAnketId
      var eror = false


      for (var i = 0; i < this.Anketjson[index].FormFiled.length; i++) {

        /*
                  if(this.Anketjson[index].FormFiled[i].type == "checkbox"){
                  let UpdateArray = {}
                 for( var s =0; s<this.FormDataJson[this.Anketjson[index].FormFiled[i].Id].Cevap.length; s++){
                    UpdateArray[this.FormDataJson[this.Anketjson[index].FormFiled[i].Id].Cevap[s]] =  true
                 } 
                 console.log(UpdateArray)
                  this.FormData.Cevap[this.Anketjson[index].FormFiled[i].Id].Cevap = UpdateArray 
        }
        */

        if (this.Anketjson[index].FormFiled[i].type == "OnayKutuluTablo") {
          let UpdateArray = {}

          for (let Sutunlar in this.FormDataJson[this.Anketjson[index].FormFiled[i].Id].Cevap) {
            UpdateArray[Sutunlar] = {}
            for (let s = 0; s < this.FormDataJson[this.Anketjson[index].FormFiled[i].Id].Cevap[Sutunlar].length; s++) {
              UpdateArray[Sutunlar][this.FormDataJson[this.Anketjson[index].FormFiled[i].Id].Cevap[Sutunlar][s]] = true
            }

          }
          this.FormDataJson[this.Anketjson[index].FormFiled[i].Id].Cevap = UpdateArray
        }


        const field = this.Anketjson[index].FormFiled[i];
        const connected = field.connected;
        if (field.config.required &&
          (!connected || !connected.question ||
            (this.FormDataJson[connected.question] && this.FormDataJson[connected.question].Cevap == connected.reply))) {



          if (this.Anketjson[index].FormFiled[i].type == "CoktanSecmeliTablo") {
            for (var j = 0; j < Object.keys(this.FormDataJson[this.Anketjson[index].FormFiled[i].Id].Cevap).length; j++) {
              // alert(this.FormDataJson[this.Anketjson[index].FormFiled[i].Id].Cevap[this.Anketjson[index].FormFiled[i].options.Satir[j].value]);
              if (!this.FormDataJson[this.Anketjson[index].FormFiled[i].Id].Cevap[this.Anketjson[index].FormFiled[i].options.Satir[j].Id]) {
                eror = true
              }
            }
            if (eror) {
              this.$toast.error(this.FormDataJson[this.Anketjson[index].FormFiled[i].Id].Text + " Alanı Zorunlu ");

            }
          }
          else if (this.Anketjson[index].FormFiled[i].type == "OnayKutuluTablo") {

            for (j = 0; j < Object.keys(this.FormDataJson[this.Anketjson[index].FormFiled[i].Id].Cevap).length; j++) {
              // alert(this.FormDataJson[this.Anketjson[index].FormFiled[i].Id].Cevap[this.Anketjson[index].FormFiled[i].options.Satir[j].value]);

              if (this.FormDataJson[this.Anketjson[index].FormFiled[i].Id].Cevap[this.Anketjson[index].FormFiled[i].options.Satir[j].Id].length == 0) {
                eror = true
              }
            }
            if (eror) {
              this.$toast.error(this.FormDataJson[this.Anketjson[index].FormFiled[i].Id].Text + " Alanı Zorunlu ");

            }
          }
          else if (this.Anketjson[index].FormFiled[i].type == "checkbox") {
            if (Object.keys(this.FormDataJson[this.Anketjson[index].FormFiled[i].Id].Cevap).length == 0) {
              this.$toast.error(this.FormDataJson[this.Anketjson[index].FormFiled[i].Id].Text + " Alanı Zorunlu ");
              eror = true
            }
          }
          else if (this.Anketjson[index].FormFiled[i].type == "rangeslider") {
            if (this.FormDataJson[this.Anketjson[index].FormFiled[i].Id].Cevap == null) {
              this.$toast.error(this.FormDataJson[this.Anketjson[index].FormFiled[i].Id].Text + " Alanı Zorunlu ");
              eror = true
            }
          }
          else {
            if (this.FormDataJson[this.Anketjson[index].FormFiled[i].Id].Cevap == null || this.FormDataJson[this.Anketjson[index].FormFiled[i].Id].Cevap.length == 0) {
              this.$toast.error(this.FormDataJson[this.Anketjson[index].FormFiled[i].Id].Text + " Alanı Zorunlu ");
              eror = true
            }
          }
        }
      }
      if (!eror) {
        //alert(JSON.stringify(this.FormDataJson['db3cff41-ab61-4c2f-a39b-1e18ae586ff6']));
        //this.FormData.Cevap =JSON.stringify(this.FormDataJson); 
        //alert(JSON.stringify(this.FormDataJson));
        this.FormData.Cevap = this.FormDataJson;
        for (var t = 0; t < this.Anketjson.length; t++) {
          for (i = 0; i < this.Anketjson[t].FormFiled.length; i++) {
            if (this.Anketjson[t].FormFiled[i].type == "checkbox") {
              let UpdateArray = {}
              if (this.FormDataJson[this.Anketjson[t].FormFiled[i].Id].Cevap && this.FormDataJson[this.Anketjson[t].FormFiled[i].Id].Cevap.length > 0) {
                for (var s = 0; s < this.FormDataJson[this.Anketjson[t].FormFiled[i].Id].Cevap.length; s++) {
                  UpdateArray[this.FormDataJson[this.Anketjson[t].FormFiled[i].Id].Cevap[s]] = true
                }
              }
              console.log(UpdateArray)
              this.FormData.Cevap[this.Anketjson[t].FormFiled[i].Id].Cevap = UpdateArray
            }
          }
        }
        this.Post("AnktAnketCevap", this.FormData).then((res) => {
          if (res) {

            this.ButtonDisabled  = true
            this.AnketBitisKontrol =true

            if (this.Cevaplayanid != null) {

              this.NormalAuth();

            }

          /*  setTimeout(() => {
              window.location.reload()
            }, 500)
       */
          }
        });

      }


    },
    NormalAuth() {
      let AnktAnketCevaplanPersonelData = {
        Anketid: this.AnktAnketId,
        Durumid: 1,
        Cevaplayanid: this.Cevaplayanid
      }

  

      this.ActionsPost({ "Service": "AnktAnketCevaplanPersonel", "Data": AnktAnketCevaplanPersonelData }).then(res => {
        if (res) {
          this.AnketBitisKontrol = true
          if (this.$route.params.Sessionkey && this.$route.params.Email) {

           //window.location.href = this.$config.WELCOME_URL
           this.$bvModal.hide("AnktAnketCevapYanitlama")

          }
        }
      });
    },
/*    
showYourIp() {
       
  this.getLocalIp()
    .then(localIp => {
      this.FormData.Clientipadress = localIp;

      this.ActionsFilterGet({
        Service: "AnktAnketCevap",
        Page: this.Page,
        Filter: "&Clientipadress=" + localIp 
        + "&Tekilkontrolid=" + this.$route.params.tekilkontrolid
        + "&Anketid=" + this.$route.params.AnktAnketId
      }).then((res) => {
        let CevapData = JSON.parse(res.Data);
        let DataSize = CevapData.length;
        if (DataSize !== 0) {
          this.AnketCevapIpKontrol = true;
        }
      });

    })
    .catch(error => console.error("IP alınırken hata oluştu:", error));


},
*/
/*
getLocalIp() {
  return new Promise((resolve, reject) => {
    let peerConnection = new RTCPeerConnection({ iceServers: [] });
    peerConnection.createDataChannel("");
    peerConnection.createOffer()
      .then(offer => peerConnection.setLocalDescription(offer))
      .catch(error => reject(error));

    peerConnection.onicecandidate = (event) => {
      if (event && event.candidate && event.candidate.candidate) {
        let ipMatch = event.candidate.candidate.match(/([0-9]{1,3}\[0-9]{1,3}\[0-9]{1,3}\[0-9]{1,3})/);
        if (ipMatch) {
          resolve(ipMatch[1]);
        }
      }
    };
  });
}
,
*/
    GoBack() {
      this.$refs.formWiz.prevTab()
      this.ButtonDisabled = false
    },

  GoNext(index) {

  let error = false
  const form = this.Anketjson[index]
  if (!form || !form.FormFiled) return

  for (let i = 0; i < form.FormFiled.length; i++) {

    const field = form.FormFiled[i]
    const fieldId = field.Id
    const fieldData = this.FormDataJson[fieldId]

    //  FormDataJson yoksa (gizli / bağlı soru)
    if (!fieldData) continue

    // connected soru kontrolü
    if (
      field.connected &&
      field.connected.question &&
      (
        !this.FormDataJson[field.connected.question] ||
        this.FormDataJson[field.connected.question].Cevap !== field.connected.reply
      )
    ) {
      continue
    }

    /* ============================  ONAY KUTULU TABLO (FORMAT)    ============================ */
 if (this.Anketjson[index].FormFiled[i].type === "OnayKutuluTablo") {
  const fieldId = this.Anketjson[index].FormFiled[i].Id
  const fieldData = this.FormDataJson[fieldId]

  if (!fieldData || !fieldData.Cevap) continue

  const updateArray = {}

  for (const satirId in fieldData.Cevap || {}) {
    updateArray[satirId] = {}

    const secimler = fieldData.Cevap[satirId] || []
    for (let s = 0; s < secimler.length; s++) {
      updateArray[satirId][secimler[s]] = true
    }
  }

  this.FormDataJson[fieldId].Cevap = updateArray
}


    /* ============================      RANGE SLIDER    ============================ */
    if (field.type === "rangeslider") {
      if (field.config?.required && fieldData.Cevap === null) {
        this.$toast.error(fieldData.Text + " Alanı Zorunlu")
        error = true
      }
    }

    /* =========================== ÇOKTAN SEÇMELİ TABLO ============================ */
    else if (field.type === "CoktanSecmeliTablo") {
      if (field.config?.required) {
        for (const satir of field.options?.Satir || []) {
          if (!fieldData.Cevap?.[satir.Id]) {
            error = true
            break
          }
        }
        if (error) {
          this.$toast.error(fieldData.Text + " Alanı Zorunlu")
        }
      }
    }

    /* ============================  CHECKBOX  ============================ */
    else if (field.type === "checkbox") {
      if (field.config?.required) {
        if (!Array.isArray(fieldData.Cevap) || fieldData.Cevap.length === 0) {
          this.$toast.error(fieldData.Text + " Alanı Zorunlu")
          error = true
        }
      }
    }

    /* ============================       DİĞER TÜRLER (input, radio, vb.)   ============================ */
    else {
      if (field.config?.required) {
        if (
          fieldData.Cevap === null ||
          fieldData.Cevap === "" ||
          (Array.isArray(fieldData.Cevap) && fieldData.Cevap.length === 0)
        ) {
          this.$toast.error(fieldData.Text + " Alanı Zorunlu")
          error = true
        }
      }
    }

    if (error) break
  }

  if (!error) {
    this.$refs.formWiz.nextTab()
  }
}
,

    BagliSoruTemizle(Soruid, event) {

      for (var t = 0; t < this.Anketjson.length; t++) {
        for (var i = 0; i < this.Anketjson[t].FormFiled.length; i++) {


          if (this.Anketjson[t].FormFiled[i].connected.question == Soruid
            && this.Anketjson[t].FormFiled[i].connected.reply != event
          ) {
            this.FormDataJson[this.Anketjson[t].FormFiled[i].Id].Cevap = ""
          }

        }
      }
    }

  },
  filters: {
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD");
      }
    },
    formatDateTable(value) {
      if (value) {
        return moment(String(value)).format("DD.MM.YYYY");
      }
    },
  },
  watch: {
    themeColor() {
      return this.bgColorChange();
    }
  },
  created() {

    this.GetData();
   
/*
    this.ActionsSingleGet({
        Service: "AnktAnket",
        Id: this.$route.params.AnktAnketId,
      }).then((Anketres) => {

        if(Anketres.Data.Ipkontrol == true)
        {
          //this.showYourIp();
            this.loadOrCreateToken();

        } else {

          let token = localStorage.getItem("tekilkontrolid");

              if (!token) {
                    token = crypto.randomUUID(); 
                    localStorage.setItem("tekilkontrolid", token);
              } else {
                      this.FormData.tekilkontrolid = token;
                }
       
        }

     });

    this.DosyaYolu = this.$config.FILES_URL;
    this.AuthKontrol2 = window.$cookies.get('eCampus');
    if (this.$route.params.Sessionkey && this.$route.params.Email) {

      let Data = {
        Email: this.$route.params.Email,
        Sessionkey: this.$route.params.Sessionkey
      }
      this.ActionsLoginSessionKey(Data).then((res) => {

        if (this.AuthKontrol2) {
          this.Cevaplayanid = this.TokenUserId;

        } else {
          var PageToplu = {
            PageNumber: "1",
            PageSize: "9999",
            PageDataSize: "1",
          }
          this.ActionsFilterGet({
            Service: this.$config.API_ACCOUNT_URL + "Account/get-userroles",
            Page: PageToplu,
            Filter: "&email=" + this.$route.params.Email,
          }).then((res) => {
            this.Cevaplayanid = res.Data.Id;
     

          });
        }

        if (res != true) {
          window.location = this.$config.LOGIN_URL
        }
      });
    }

*/


  }

};
</script>
<style lang="scss">
.custom-control-input {
  margin-right: 5px !important;
}

.custom-radio .custom-control-input {
  width: 1.2em;
  height: 1.2em;
}
</style>

<template>
  <Loader style="margin-top: 33px">
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <div v-if="Anketkapalimi == false">
      
            <div v-if="AnketData.Onay || AnketData.Testkullanim">
              <div v-if="AnketBitisKontrol == false">
          
                <b-modal id="AnktAnketCevapYanitlama" size="lg" :title="$t('AnktAnketCevap.YanitlamaModal.Baslik')"
                  title-class="font-18" hide-footer>
                    
                  <b-form-radio v-if="AnketData.Ertele && !ErteleKontrol" v-model="AnktAnketCevapYanitlamaCevap"
                    class="mb-3" :value="2" :name="AnktAnketCevapYanitlamaCevap.Id"
                    @change="AnktAnketCevapYanitlamaCevap = $event">{{
                      $t("AnktAnketCevap.YanitlamaModal.Ertele")
                    }}</b-form-radio>
                  <b-form-radio v-if="AnketData.Yanitlamakistemiyorum" v-model="AnktAnketCevapYanitlamaCevap" class="mb-3"
                    :value="3" :name="AnktAnketCevapYanitlamaCevap" @change="AnktAnketCevapYanitlamaCevap = $event">
                    {{
                      $t("AnktAnketCevap.YanitlamaModal.YanitlamakIstemiyorum")
                    }}</b-form-radio>

                  <button @click="onSubmitCevapYanitlama()" type="button" class="btn btn-primary">
                    {{ $t("AnktAnketCevap.YanitlamaModal.KaydetButton") }}
                  </button>
                </b-modal>


                <div class="row" v-if="(!AnketCevapIpKontrol &&
                  !AnketCevapKullaniciKontrol &&
                  this.$options.filters.formatDate(Baslamatarihi) <=
                  this.$options.filters.formatDate(FormData.Created) &&
                  (!Bitistarihi ||
                    this.$options.filters.formatDate(Bitistarihi) >=
                    this.$options.filters.formatDate(FormData.Created))) || AnketData.Testkullanim
                  ">
                  <div class="
                        d-flex
                        justify-content-center
                        align-items-center
                        flex-nowrap flex-column
                        mt-n4
                      ">
              

                    <div class="card w-75 border-top" :style="{
                      'border-top-color': themeColor + ' !important',
                    }">
                      <div class="card-body">
                        <div class="text-sm-center">
                          <h2>{{ AnketData.Baslik }}</h2>
                          <img class="img-fluid" v-if="AnketData.Filename" :src="DosyaYolu + AnketData.Filename"
                            style="max-height: 250px" />
                        </div>
                        <span v-html="AnketData.Aciklama"></span><br />
                      </div>
                    </div>

                    <div class="card w-75 rounded-3 shadow-lg" :style="{
                      'border-top-color': themeColor + ' !important',
                    }">
                      <div class="card-body">
                        <form-wizard  v-if="Anketjson && Object.keys(FormDataJson).length && !AnketBitisKontrol" 
                        :color="themeColor" @on-complete="onSubmit" ref="formWiz" :hide-buttons="true">
                          <h5 class="d-none">{{ Update }}</h5>
                          <tab-content v-for="(Data, DataIndex) in Anketjson" :key="DataIndex" @on-complete="onSubmit"
                            :icon="Data.FormIcon" :title="Data.FormTitle">
                            <div>
                              <div class="row">
                                <div class="col-12">
                                  <div v-for="(
                                        FormFiled, FormFiledIndex
                                      ) in Data.FormFiled" :key="FormFiledIndex">
                                    <div class="form-group row mb-3" v-if="!FormFiled.connected ||
      !FormFiled.connected.question ||
      (FormDataJson[FormFiled.connected.question] &&
       FormDataJson[FormFiled.connected.question].Cevap === FormFiled.connected.reply)">
                                      <label class="col-form-label"
                                        :class="FormFiled.type != ('radiobutton') ? 'col-md-3' : 'col-md-12'"
                                        v-if="FormFiled.type != ('CoktanSecmeliTablo')">{{
                                          FormFiled.props.title
                                        }}</label>
                                      <div
                                        :class="FormFiled.type != ('CoktanSecmeliTablo') && FormFiled.type != ('radiobutton') ? 'col-md-9' : 'col-md-12'">
                                        <input :placeholder="FormFiled.config.placeHolder
                                          " v-if="FormFiled.type == 'input'" :type="FormFiled.config.type"
                                          :min="FormFiled.config.min" :max="FormFiled.config.max" class="form-control"
                                          v-model="FormDataJson[FormFiled.Id].Cevap
                                            " />
                                        <textarea :placeholder="FormFiled.config.placeHolder
                                          " v-if="FormFiled.type == 'textarea'" type="text" class="form-control"
                                          v-model="FormDataJson[FormFiled.Id].Cevap
                                            " />
                                        <div v-if="FormFiled.type == 'radiobutton'">
                                          <div class="row">
                                            <div class="col-md-auto" v-for="(
                                                  Options, OptionsIndex
                                                ) in FormFiled.options" :key="OptionsIndex">
                                              <b-form-radio @ v-model="FormDataJson[FormFiled.Id]
                                                .Cevap
                                                " :value="Options.Id" :name="FormFiled.Id" @change="
  (FormDataJson[
    FormFiled.Id
  ].Cevap = $event),
    (Update = Update + 1), BagliSoruTemizle(FormFiled.Id, $event)
    ">
                                                {{
                                                  Options.value
                                                }}</b-form-radio>
                                            </div>
                                          </div>
                                        </div>

                                        <div v-if="FormFiled.type == 'checkbox'">
                                          <b-form-group>
                                            <b-form-checkbox-group v-model="FormDataJson[FormFiled.Id].Cevap
                                              " name="flavour-2">
                                              <div class="row">
                                                <div class="col-md-3" v-for="(
                                                      Options, OptionsIndex
                                                    ) in FormFiled.options" :key="OptionsIndex">
                                                  <b-form-checkbox :value="Options.Id">{{
                                                    Options.value
                                                  }}</b-form-checkbox>
                                                </div>
                                              </div>
                                            </b-form-checkbox-group>
                                          </b-form-group>
                                        </div>

                                        <select v-if="FormFiled.type == 'combobox'" class="form-select" v-model="FormDataJson[FormFiled.Id].Cevap
                                          "
                                          @change="Update = Update + 1, BagliSoruTemizle(FormFiled.Id, $event.target.value)">
                                          <option v-for="(
                                                Options, OptionsIndex
                                              ) in FormFiled.options" :key="OptionsIndex" :value="Options.Id">
                                            {{ Options.value }}
                                          </option>
                                        </select>

                                        <b-form-input :placeholder="FormFiled.config.placeHolder
                                          " v-if="FormFiled.type == 'date'" v-model="FormDataJson[FormFiled.Id].Cevap
    " type="date"></b-form-input>

                                        <b-form-input :placeholder="FormFiled.config.placeHolder
                                          " v-if="FormFiled.type == 'time'" v-model="FormDataJson[FormFiled.Id].Cevap
    " type="time"></b-form-input>

                                        <input v-if="FormFiled.type == 'file'" type="file" class="form-control"
                                          v-on:change="
                                            FileUpload($event, FormFiled.Id)
                                            " />
                                        <div v-if="FormFiled.type == 'rangeslider'">
                                          <br />
                                          <div class="row">
                                            <div class="col-md-1" v-for="(n, index) in parseInt(
                                              FormFiled.options[0].max
                                            ) + 1" :key="index">
                                              <b-form-radio v-if="n > FormFiled.options[0].min
                                                " v-model="FormDataJson[FormFiled.Id]
    .Cevap
    " :value="index" class="mb-3" :name="FormFiled.Id" @change="
    FormDataJson[
      FormFiled.Id
    ].Cevap = $event
    "></b-form-radio><span v-if="n > FormFiled.options[0].min
    ">{{ index }}</span>
                                            </div>
                                          </div>

                                          <!--  <vue-slide-bar
                                              v-model="FormDataJson[FormFiled.Id].Cevap"
                                              :min="parseInt(FormFiled.options[0].min)"
                                              :max="parseInt(FormFiled.options[0].max)"
                                            /><br />
                                            <div class="row">
                                              <div class="col-6">
                                                <b> {{ FormFiled.options[0].mintitle }} </b>
                                              </div>
                                              <div class="col-6">
                                                <div class="text-sm-end">
                                                  <b> {{ FormFiled.options[0].maxtitle }} </b>
                                                </div>
                                              </div>
                                            </div>-->
                                        </div>

                                        <div class="table-responsive"
                                          style="border: 3px solid #f5f5dc ;border-radius: 5px; " v-if="FormFiled.type ==
                                            'CoktanSecmeliTablo'
                                            ">
                                          <table class="table mb-0">
                                            <thead style="border-bottom: 3px solid #f5f5dc">
                                              <tr>
                                                <th v-if="FormFiled.type == 'CoktanSecmeliTablo'" class="col-md-3">
                                                  <label class="col-form-label">{{ FormFiled.props.title }}</label>
                                                </th>
                                                <th>#</th>
                                                <th v-for="(
                                                      Options, OptionsIndex
                                                    ) in FormFiled.options.Sutun" :key="OptionsIndex">
                                                  {{ Options.value }}
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr v-for="(
                                                    Satir, SatirIndex
                                                  ) in FormFiled.options.Satir" :key="SatirIndex">
                                                <th scope="row" class="col-md-6">
                                                  {{ Satir.value }}
                                                </th>
                                                <th></th>
                                                <td v-for="(
                                                      Sutun, SutunIndex
                                                    ) in FormFiled.options.Sutun" :key="SutunIndex">
                                                  <b-form-radio v-model="FormDataJson[FormFiled.Id]
                                                    .Cevap[Satir.Id]
                                                    " class="mb-3" :value="Sutun.Id" :name="'Radio' +
    FormFiled.Id +
    SatirIndex
    " @change="
    FormDataJson[
      FormFiled.Id
    ].Cevap.Cevap[Satir.Id] =
    $event
    "></b-form-radio>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>

                                        <div class="table-responsive" v-if="FormFiled.type == 'OnayKutuluTablo'
                                          ">
                                          <table class="table mb-0">
                                            <thead>
                                              <tr>
                                                <th>#</th>
                                                <th v-for="(
                                                      Options, OptionsIndex
                                                    ) in FormFiled.options.Sutun" :key="OptionsIndex">
                                                  {{ Options.value }}
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr v-for="(
                                                    Satir, index
                                                  ) in FormFiled.options.Satir" v-bind:key="index">
                                                <th scope="row">
                                                  {{ Satir.value }}
                                                </th>

                                                <td v-for="(
                                                      Sutun, SutunIndex
                                                    ) in FormFiled.options.Sutun" :key="SutunIndex">

                                                  <input type="checkbox" :id="'Check' +
                                                    FormFiled.Id +
                                                    index
                                                    " :value="Sutun.Id" v-model="FormDataJson[FormFiled.Id]
    .Cevap[Satir.Id]
    " />
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-6">
                                <div class="text-sm">
                                  <button v-if="DataIndex != 0" @click="GoBack" type="button" class="btn btn-primary"
                                    v-bind:style="{
                                      'background-color': [themeColor],
                                      border: 'none',
                                    }">
                                    {{ $t("AnktAnketCevap.Page.Geri") }}
                                  </button>
                                </div>
                              </div>
                              <div class="col-6">
                                <div class="text-sm-end">
                                  <button v-if="DataIndex != Anketjson.length - 1" @click="GoNext(DataIndex)"
                                    type="button" class="btn btn-primary" v-bind:style="{
                                      'background-color': [themeColor],
                                      border: 'none',
                                    }">
                                    {{ $t("AnktAnketCevap.Page.Ileri") }}
                                  </button>
                                  <button v-if="DataIndex == Anketjson.length - 1" @click="onSubmit(DataIndex)" :disabled="ButtonDisabled"
                                    type="button" class="btn btn-primary" v-bind:style="{
                                      'background-color': [themeColor],
                                      border: 'none',
                                    }">
                                    {{ $t("AnktAnketCevap.Page.Tamamla") }}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </tab-content>
                        </form-wizard>
                      </div>
                    </div>
                  </div>
                </div>

                            <!-- <div class="row" v-if="this.$options.filters.formatDate(Baslamatarihi) > this.$options.filters.formatDate(FormData.Created) || (Bitistarihi && this.$options.filters.formatDate(Bitistarihi) < this.$options.filters.formatDate(FormData.Created))">
                        <div class="text-sm-center">
                          <h2>{{ $t("AnktAnketCevap.Page.DateError") }}</h2>
                        </div>
                      </div>

                      <div class="row" v-if="AnketCevapIpKontrol">
                        <div class="text-sm-center">
                          <h2>{{ $t("AnktAnketCevap.Page.IpError") }}</h2>
                        </div>
                      </div>

                      <div class="row" v-if="AnketCevapKullaniciKontrol">
                        <div class="text-sm-center">
                          <h2>{{ $t("AnktAnketCevap.Page.KullaniciKontrol") }}</h2>
                        </div>
                      </div>
                  
                    <div v-else>
                      <div class="row">
                        <div class="text-sm-center">
                          <h2>{{ $t("AnktAnketCevap.Page.AnketBitisKontrol") }}</h2>
                        </div>
                      </div>
                    </div>
                
                  <div v-else>
                    <div class="row">
                      <div class="text-sm-center">
                        <h2>{{ Anketkapalimesaji }}</h2>
                      </div>
                    </div>
                  </div> -->

                <mesaj v-if="this.$options.filters.formatDate(Baslamatarihi) >
                  this.$options.filters.formatDate(FormData.Created) ||
                  (Bitistarihi &&
                    this.$options.filters.formatDate(Bitistarihi) <
                    this.$options.filters.formatDate(FormData.Created))
                  " class="w-75 mx-auto" tip="alert-warning" title="Uyarı!"
                  :text="$t('AnktAnketCevap.Page.DateError')">
                </mesaj>

                <mesaj v-if="AnketCevapIpKontrol" class="w-75 mx-auto" tip="alert-warning" title="Uyarı!"
                  :text="$t('AnktAnketCevap.Page.IpError')"></mesaj>

                  <mesaj v-if="AnketTamamlandiKontrol || AnketBitisKontrol" class="w-75 mx-auto" tip="alert-success" title="Tebrikler!"
                  text="Anket Tamamlandı"></mesaj>

                <mesaj v-if="AnketCevapKullaniciKontrol" class="w-75 mx-auto" tip="alert-warning" title="Uyarı!"
                  :text="$t('AnktAnketCevap.Page.KullaniciKontrol')"></mesaj>
              </div>
              <mesaj v-else class="w-75 mx-auto" tip="alert-success" title="Tebrikler!"
                :text="$t('AnktAnketCevap.Page.AnketBitisKontrol')"></mesaj>
            </div>
            <mesaj v-else class="w-75 mx-auto" tip="alert-warning" title="Hata!"
              :text="$t('AnktAnketCevap.Page.Anketonaymesaji')"></mesaj>
          </div>
          <mesaj v-else class="w-75 mx-auto" tip="alert-warning" title="Uyarı!" :text="Anketkapalimesaji"></mesaj>
          <mesaj class="w-75 mx-auto" tip="alert-warning" title="Hata!" :text="$t('AnktAnketCevap.Page.AnketGetError')"
            v-if="!AnktSucceeded"></mesaj>
        </div>
      </div>
    </div>
  </Loader>
</template>

<style>
.wizard-icon-circle.checked {
  color: #5f5f5f;
}

.border-top {
  border-top: solid 12px !important;
  box-shadow: 0 -10px 36px rgba(0, 0, 0, 0.49) !important;
  -webkit-box-shadow: 0 -10px 36px rgba(0, 0, 0, 0.49) !important;
  border-radius: 0px 0px 22px 22px !important;
}
</style>
